module.exports = __webpack_public_path__ + "static/media/GillSans.ec0a8845.svg";